"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/* eslint-disable no-param-reassign */

/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var constants_1 = require("../../constants");

var styles = tslib_1.__importStar(require("./Icon.style"));

function Icon(_ref) {
  var className = _ref.className,
      name = _ref.name,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'icon' : _ref$alt,
      hover = _ref.hover,
      onClick = _ref.onClick;

  function handleMouseEnter(_ref2) {
    var currentTarget = _ref2.currentTarget;

    if (hover) {
      currentTarget.src = "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(hover, ".svg");
    }
  }

  function handleMouseLeave(_ref3) {
    var currentTarget = _ref3.currentTarget;
    currentTarget.src = "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(name, ".svg");
  }

  return jsx_runtime_1.jsx("img", {
    className: className,
    css: [styles.icon, onClick && styles.clickable],
    src: "".concat(constants_1.S3_RESOURCE_ICONS, "/").concat(name, ".svg"),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    alt: alt || name,
    onClick: onClick
  }, void 0);
}

exports.default = react_1.memo(Icon);